import { render, staticRenderFns } from "./propertyDetails.vue?vue&type=template&id=60c8ff8d"
import script from "./propertyDetails.vue?vue&type=script&lang=js"
export * from "./propertyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports